import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class LazyErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Aktualisiere State, damit das Fallback UI gerendert wird
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Logge den Fehler für Debugging
    console.error('Lazy Component Loading Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI wenn Lazy Loading fehlschlägt
      return this.props.fallback || (
        <div style={{
          padding: '2rem',
          textAlign: 'center' as const,
          background: 'var(--card-background)',
          borderRadius: '1rem',
          margin: '1rem'
        }}>
          <h3>⚠️ Fehler beim Laden</h3>
          <p>Entschuldigung, diese Komponente konnte nicht geladen werden.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '0.5rem 1rem',
              background: 'var(--primary-color)',
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer'
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default LazyErrorBoundary;
